import React from 'react';
import { Modal } from 'antd';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getMapLocations, getShowMapViewModal, showMapView, getShowSequenceNumbers } from '../../store/app-ui.store';
import RZMap from '../RZMap';

const MapView = (): JSX.Element => {
  const showModal = useAppSelector(getShowMapViewModal);
  const locations = useAppSelector(getMapLocations);
  const showSequenceNumbers = useAppSelector(getShowSequenceNumbers);
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(showMapView({ show: false, locations: [] }));
  };

  return (
    <Modal visible={showModal} title="Locations" onCancel={handleClose} closeIcon onOk={handleClose} destroyOnClose>
      <div style={{ height: 500, width: '100%' }}>
        <RZMap markerPositions={locations} showSequenceNumbers={showSequenceNumbers || false} />
      </div>
    </Modal>
  );
};

export default MapView;
